import React, {useState} from 'react';
import styles from './Documents.module.css';
import ListItem from './list/ListItem';
import ViewDocumentPopup from '../../../../popup/ViewDocumentPopup/ViewDocumentPopup';
import ModuleCard from '../../../appointment/components/moduleCard/ModuleCard';
import ModuleEmptyState from '../../../appointment/components/moduleCard/ModuleEmptyState';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { useParams } from 'react-router-dom';
import PatientAttachments from '../../../appointment/components/patientAttachments/PatientAttachments';
import { useRoleAccess } from '../../../../hooks/useRoleAccess';

/**
 * Seção Documentos da ficha: documentos emitidos (atestados, declarações,
 * receitas...) e, para quem atende, o card de anexos.
 */
const Documents = ({ patientData, list }) => {

    const { id: patientId } = useParams();
    const { canAccessHealthData } = useRoleAccess();
    const [currentDocumentData, setCurrentDocumentData] = useState(null);

    // Anexos são dado de saúde: mesma regra de acesso da seção "Saúde" (Patient.js)
    const canAccessAttachments = canAccessHealthData();

    const selectItemHandler = (id) => {
        setCurrentDocumentData(list.find(item => item.id == id));
    }

    const OnHide = () => {
        setCurrentDocumentData(null);
    }

    return (
        <div className={styles.column}>
            <ModuleCard
                title="Documentos"
                icon={<DescriptionOutlinedIcon />}
                description="Documentos emitidos"
                accent="purple"
            >
                {list.length === 0 ? (
                    <ModuleEmptyState icon={<DescriptionOutlinedIcon />} text="Nenhum documento emitido." />
                ) : (
                    <div className={styles.containerList}>
                        {list.map((item, index) => (
                            <ListItem
                                key={index}
                                id={item.id}
                                date={item.date}
                                title={item.title}
                                description={item.description}
                                onSelect={selectItemHandler}
                            />
                        ))}
                    </div>
                )}
            </ModuleCard>
            {currentDocumentData && <ViewDocumentPopup data={currentDocumentData} patientData={patientData} OnHide={OnHide}/> }

            {canAccessAttachments && (
                <PatientAttachments
                    patientId={patientId}
                    enabled={true}
                />
            )}
        </div>
    );
};

export default Documents;
